"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTours = exports["default"] = exports.createTourBoardExport = exports.assignAssetToTour = exports.TourBoardPresentation = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactQuery = require("react-query");

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _mapping = require("@nicbase/mapping");

var _request = require("@nicbase/request");

var _classnames = _interopRequireDefault(require("classnames"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _nicbaseExportButton = _interopRequireDefault(require("nicbase-export-button"));

var _nicbaseFilters = require("nicbase-filters");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _nicbaseWidgetUtils = require("nicbase-widget-utils");

var _assetRequestDialog = _interopRequireDefault(require("./asset-request-component/asset-request-dialog"));

var _detailsPopupComponent = _interopRequireDefault(require("./details-component/details-popup-component"));

var _intelligentCopyComponent = _interopRequireDefault(require("./intelligent-copy-component/intelligent-copy-component"));

var _reportExportDialog = _interopRequireDefault(require("./report-export-component/report-export-dialog"));

var _settings = _interopRequireDefault(require("./settings/settings"));

var _columnDefinition = require("./table/column-definition");

var _tourBoardTable = _interopRequireDefault(require("./table/tour-board-table"));

var _constants = require("./constants");

var _railDetailsComponent = _interopRequireDefault(require("./rail-details-component"));

var _railTourComponent = _interopRequireDefault(require("./rail-tour-component"));

var _roadTourComponent = _interopRequireDefault(require("./road-tour-component"));

var _useTourboardAssets2 = _interopRequireDefault(require("./useTourboardAssets"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var PAGE_SIZE = 30;
var EXPORT_LIMIT = 10000;

var getTours = function getTours(portalId, widgetId) {
  var dynamicFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var dynamicPaging = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var dynamicSorters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var action = {
    type: 'FIND_TOURS_FOR_TOUR_BOARD_REQUEST',
    headers: {
      version: 'v1',
      portalId: portalId,
      widgetId: widgetId
    },
    body: {
      dynamicFilters: dynamicFilters,
      dynamicPaging: dynamicPaging,
      dynamicSorters: dynamicSorters
    }
  };
  return action;
};

exports.getTours = getTours;

var assignAssetToTour = function assignAssetToTour(tourId, assetId, assetType, portalId) {
  return {
    type: 'ASSIGN_ASSET_TO_TOUR_EVENT_REQUEST',
    headers: {
      version: 'v1',
      portalId: portalId
    },
    body: {
      id: tourId,
      assetId: assetId,
      assetType: assetType
    }
  };
};

exports.assignAssetToTour = assignAssetToTour;

var createTourBoardExport = function createTourBoardExport(portalId) {
  var dynamicFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var dynamicSorters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var dynamicPaging = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var visibleColumns = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  return {
    type: 'CREATE_TOUR_BOARD_EXPORT_REQUEST',
    headers: {
      version: 'v1',
      portalId: portalId
    },
    body: {
      filters: {
        dynamicFilters: dynamicFilters,
        dynamicSorters: dynamicSorters,
        dynamicPaging: dynamicPaging
      },
      visibleColumns: visibleColumns
    }
  };
};

exports.createTourBoardExport = createTourBoardExport;

var getDefaultTourObject = function getDefaultTourObject(user) {
  var _tourDefaults$report, _tourDefaults$report$, _tourDefaults$report2, _tourDefaults$report$2, _tourDefaults$report3, _tourDefaults$report$3, _tourDefaults$report4;

  var tourDefaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    alarms: tourDefaults.alarms || [],
    wayPoints: tourDefaults.wayPoints || [{
      frontendId: 'endPOI',
      type: _constants.WAYPOINT_TYPES.END,
      poiId: null,
      poiTriggerCondition: _constants.TRIGGER_CONDITIONS.POI_ENTERED
    }, {
      frontendId: 'startPOI',
      type: _constants.WAYPOINT_TYPES.START,
      poiId: null,
      poiTriggerCondition: _constants.TRIGGER_CONDITIONS.POI_EXITED
    }],
    scheduledStartTime: null,
    scheduledEndTime: null,
    realStartTime: null,
    realEndTime: null,
    assetId: undefined,
    assetType: null,
    name: '',
    etaProvider: tourDefaults.etaProvider || _constants.ETA_PROVIDERS.NOTHING,
    route: null,
    delayedStartLimitAlarm: null,
    delayedEndLimitAlarm: null,
    emailRecipients: tourDefaults.emailRecipients || [{
      recipient: user.email,
      assignedAlarms: true,
      routeAlarms: true,
      etaAlarms: true,
      startStopAlarms: true,
      delayedStartEndAlarms: false
    }],
    smsRecipients: tourDefaults.smsRecipients || [],
    report: {
      recipients: (tourDefaults === null || tourDefaults === void 0 ? void 0 : (_tourDefaults$report = tourDefaults.report) === null || _tourDefaults$report === void 0 ? void 0 : _tourDefaults$report.recipients) || [],
      showGeoInformation: (_tourDefaults$report$ = tourDefaults === null || tourDefaults === void 0 ? void 0 : (_tourDefaults$report2 = tourDefaults.report) === null || _tourDefaults$report2 === void 0 ? void 0 : _tourDefaults$report2.showGeoInformation) !== null && _tourDefaults$report$ !== void 0 ? _tourDefaults$report$ : false,
      shareViaEmail: (_tourDefaults$report$2 = tourDefaults === null || tourDefaults === void 0 ? void 0 : (_tourDefaults$report3 = tourDefaults.report) === null || _tourDefaults$report3 === void 0 ? void 0 : _tourDefaults$report3.shareViaEmail) !== null && _tourDefaults$report$2 !== void 0 ? _tourDefaults$report$2 : true,
      uploadAsIdocFormat: (_tourDefaults$report$3 = tourDefaults === null || tourDefaults === void 0 ? void 0 : (_tourDefaults$report4 = tourDefaults.report) === null || _tourDefaults$report4 === void 0 ? void 0 : _tourDefaults$report4.uploadAsIdocFormat) !== null && _tourDefaults$report$3 !== void 0 ? _tourDefaults$report$3 : false
    },
    segments: [],
    dataRequest: null,
    etaAlarmsEnabled: false
  };
};

var makeFilter = function makeFilter(_ref) {
  var assetIds = _ref.assetIds,
      name = _ref.name,
      tourStatus = _ref.tourStatus,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      externalId = _ref.externalId,
      startWayPointId = _ref.startWayPointId,
      endWayPointId = _ref.endWayPointId,
      linkedPortals = _ref.linkedPortals,
      isMine = _ref.isMine,
      portalId = _ref.portalId,
      customerName = _ref.customerName,
      railwayUndertaking = _ref.railwayUndertaking,
      loaded = _ref.loaded,
      projectIds = _ref.projectIds,
      externalProjectReference = _ref.externalProjectReference;
  var statusArguments = [];
  var loadedArguments = [];
  var dateArguments = [(0, _nicbaseFilters.and)((0, _nicbaseFilters.lessThanEqual)('realStartTime', (0, _momentTimezone["default"])(startDate.until).endOf('day').toISOString(), 'DateTime'), (0, _nicbaseFilters.greaterThanEqual)('realStartTime', (0, _momentTimezone["default"])(startDate.from).startOf('day').toISOString(), 'DateTime'), (0, _nicbaseFilters.lessThanEqual)('realEndTime', (0, _momentTimezone["default"])(endDate.until).endOf('day').toISOString(), 'DateTime'), (0, _nicbaseFilters.greaterThanEqual)('realEndTime', (0, _momentTimezone["default"])(endDate.from).startOf('day').toISOString(), 'DateTime'))];

  if (tourStatus.running) {
    statusArguments.push((0, _nicbaseFilters.equal)('status', _constants.TOUR_STATUS.RUNNING, 'String'));
    dateArguments = [(0, _nicbaseFilters.and)((0, _nicbaseFilters.lessThanEqual)('realStartTime', (0, _momentTimezone["default"])(startDate.until).endOf('day').toISOString(), 'DateTime'), (0, _nicbaseFilters.greaterThanEqual)('realStartTime', (0, _momentTimezone["default"])(startDate.from).startOf('day').toISOString(), 'DateTime'), (0, _nicbaseFilters.lessThanEqual)('calculatedEndTime', (0, _momentTimezone["default"])(endDate.until).endOf('day').toISOString(), 'DateTime'), (0, _nicbaseFilters.greaterThanEqual)('calculatedEndTime', (0, _momentTimezone["default"])(endDate.from).startOf('day').toISOString(), 'DateTime'))];
  }

  if (tourStatus.waiting) {
    statusArguments.push((0, _nicbaseFilters.equal)('status', _constants.TOUR_STATUS.WAITING, 'String'));
    dateArguments = [(0, _nicbaseFilters.and)((0, _nicbaseFilters.or)((0, _nicbaseFilters.lessThanEqual)('plannedStartTime', (0, _momentTimezone["default"])(startDate.until).endOf('day').toISOString(), 'DateTime'), (0, _nicbaseFilters.lessThanEqual)('scheduledStartTime', (0, _momentTimezone["default"])(startDate.until).endOf('day').toISOString(), 'DateTime')), (0, _nicbaseFilters.or)((0, _nicbaseFilters.greaterThanEqual)('plannedStartTime', (0, _momentTimezone["default"])(startDate.from).startOf('day').toISOString(), 'DateTime'), (0, _nicbaseFilters.greaterThanEqual)('scheduledStartTime', (0, _momentTimezone["default"])(startDate.from).startOf('day').toISOString(), 'DateTime'))), (0, _nicbaseFilters.or)((0, _nicbaseFilters.and)((0, _nicbaseFilters.lessThanEqual)('plannedEndTime', (0, _momentTimezone["default"])(endDate.until).endOf('day').toISOString(), 'DateTime'), (0, _nicbaseFilters.lessThanEqual)('scheduledEndTime', (0, _momentTimezone["default"])(endDate.until).endOf('day').toISOString(), 'DateTime')), (0, _nicbaseFilters.and)((0, _nicbaseFilters.greaterThanEqual)('plannedEndTime', (0, _momentTimezone["default"])(endDate.from).startOf('day').toISOString(), 'DateTime'), (0, _nicbaseFilters.greaterThanEqual)('scheduledEndTime', (0, _momentTimezone["default"])(endDate.from).startOf('day').toISOString(), 'DateTime')))];
  }

  if (loaded !== null && loaded !== void 0 && loaded.includes('LOADED')) {
    loadedArguments.push((0, _nicbaseFilters.equal)('loaded', true, 'Boolean'));
  }

  if (loaded !== null && loaded !== void 0 && loaded.includes('NOT_LOADED')) {
    loadedArguments.push((0, _nicbaseFilters.or)((0, _nicbaseFilters.equal)('loaded', false, 'Boolean'), (0, _nicbaseFilters.isNull)('loaded')));
  }

  if (tourStatus.finished) {
    statusArguments.push((0, _nicbaseFilters.equal)('status', _constants.TOUR_STATUS.FINISHED, 'String'));
  }

  if (tourStatus.received) {
    statusArguments.push((0, _nicbaseFilters.and)((0, _nicbaseFilters.equal)('haulerPortalId', portalId, 'Integer'), (0, _nicbaseFilters.isNull)('assetId', null, 'Integer')));
  }

  if (tourStatus.requested) {
    statusArguments.push((0, _nicbaseFilters.and)((0, _nicbaseFilters.equal)('isMine', true, 'Boolean'), (0, _nicbaseFilters.isNull)('assetId', null, 'Integer'), (0, _nicbaseFilters.isNotNull)('haulerPortalId', null, 'Integer')));
  }

  return _nicbaseFilters.and.apply(void 0, [(0, _nicbaseFilters.isIn)('assetId', assetIds, 'Integer'), (0, _nicbaseFilters.isIn)('projectId', projectIds, 'String'), (0, _nicbaseFilters.isIn)('serviceProviderPortalId', linkedPortals, 'Integer'), (0, _nicbaseFilters.isIn)('startWayPointId', startWayPointId, 'Integer'), (0, _nicbaseFilters.isIn)('endWayPointId', endWayPointId, 'Integer'), (0, _nicbaseFilters.like)('externalId', externalId, 'String'), (0, _nicbaseFilters.like)('name', name, 'String'), (0, _nicbaseFilters.like)('externalProjectReference', externalProjectReference, 'String'), (0, _nicbaseFilters.equal)('isMine', isMine, 'Boolean')].concat(_toConsumableArray(dateArguments), [_nicbaseFilters.or.apply(void 0, statusArguments), // rail
  _nicbaseFilters.or.apply(void 0, loadedArguments), (0, _nicbaseFilters.like)('additionalData.railInfo.customerName', customerName, 'String'), (0, _nicbaseFilters.like)('additionalData.railInfo.railwayUndertaking', railwayUndertaking, 'String')]));
};

var TourBoardPresentation = function TourBoardPresentation(_ref2) {
  var _filters$values$tourS, _filters$values$tourS2, _filters$values$tourS3, _filters$values$tourS4, _filters$values$tourS5, _filters$values$name, _filters$values$exter, _filters$values$custo, _filters$values$railw, _filters$values$exter2;

  var user = _ref2.user,
      filters = _ref2.filters,
      emitConnectEvent = _ref2.emitConnectEvent,
      settings = _ref2.settings,
      updateSettings = _ref2.updateSettings,
      visibleColumns = _ref2.visibleColumns,
      getAlarmInformationListFromBackend = _ref2.getAlarmInformationListFromBackend,
      getPoisFromBackend = _ref2.getPoisFromBackend,
      getLinkedPortalsInformationListFromBackend = _ref2.getLinkedPortalsInformationListFromBackend,
      getTourAlarms = _ref2.getTourAlarms,
      exportTourReport = _ref2.exportTourReport,
      alarms = _ref2.alarms,
      onExportDispatch = _ref2.onExportDispatch,
      id = _ref2.id,
      portalId = _ref2.portalId,
      intl = _ref2.intl,
      isEditActive = _ref2.isEditActive,
      responsiveMode = _ref2.responsiveMode,
      tourAlarms = _ref2.tourAlarms,
      hasPermissions = _ref2.hasPermissions,
      linkedPortals = _ref2.linkedPortals,
      downloadTourImportTemplate = _ref2.downloadTourImportTemplate;
  var firstUpdate = (0, _react.useRef)(true);
  var tableRef = (0, _react.useRef)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var timezone = user.timezone,
      locale = user.locale;

  var _useTourboardAssets = (0, _useTourboardAssets2["default"])(),
      assets = _useTourboardAssets.data;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      outsideClick = _useState2[0],
      setOutsideClick = _useState2[1];

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useState3 = (0, _react.useState)({
    from: _momentTimezone["default"].tz((0, _momentTimezone["default"])().locale(locale), timezone).startOf('day').toISOString(),
    until: _momentTimezone["default"].tz((0, _momentTimezone["default"])().locale(locale), timezone).endOf('day').toISOString(),
    sortBy: 'plannedStartTime',
    sortDirection: 'DESC',
    selectedTour: null,
    isReportExportPopupActive: false,
    isIntelligentCopyPopupActive: false,
    isEditTourPopupActive: false,
    isDetailsPopupActive: false,
    isRailDialogOpen: false,
    isAssetRequestPopupActive: false,
    tourToExport: getDefaultTourObject(user, settings === null || settings === void 0 ? void 0 : settings.tourDefaults),
    tourToEdit: getDefaultTourObject(user, settings === null || settings === void 0 ? void 0 : settings.tourDefaults),
    tempSettings: {
      visibleColumns: visibleColumns
    },
    currentPageNumber: 0
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1]; // filters


  var assetFilter = (0, _nicbaseFilters.useFilterableSelectionListWithFilters)('assetIds', filters);
  var startWayPointId = (0, _nicbaseFilters.useFilterableSelectionListWithFilters)('startWayPointId', filters);
  var endWayPointId = (0, _nicbaseFilters.useFilterableSelectionListWithFilters)('endWayPointId', filters);
  var startDateFilter = (0, _nicbaseFilters.useFilterableSelectionListWithFilters)('startDate', filters);
  var endDateFilter = (0, _nicbaseFilters.useFilterableSelectionListWithFilters)('endDate', filters);
  var linkedPortalsFilter = (0, _nicbaseFilters.useFilterableSelectionListWithFilters)('linkedPortals', filters);
  var isMine = (0, _nicbaseFilters.useFilterableSelectionListWithFilters)('isMine', filters);
  var projectsFilter = (0, _nicbaseFilters.useFilterableSelectionListWithFilters)('projects', filters);
  var debouncedName = (0, _hooks.useDebounce)(filters.values.name, 400);
  var debouncedExternalId = (0, _hooks.useDebounce)(filters.values.externalId, 400);
  var debouncedExternalProjectReference = (0, _hooks.useDebounce)(filters.values.externalProjectReference, 400);
  var externalIdInput = (0, _react.useRef)();
  var nameInput = (0, _react.useRef)();
  var externalProjectReferenceInput = (0, _react.useRef)(); // rails

  var loadedFilter = (0, _nicbaseFilters.useFilterableSelectionListWithFilters)('loaded', filters);
  var debouncedCustomerName = (0, _hooks.useDebounce)(filters.customerName, 400);
  var debouncedRailwayUndertaking = (0, _hooks.useDebounce)(filters.railwayUndertaking, 400);
  var customerNameInput = (0, _react.useRef)();
  var railwayUndertakingInput = (0, _react.useRef)();
  var loadedTypes = [{
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.loaded",
      tagName: "span"
    }),
    value: 'LOADED'
  }, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.notLoaded",
      tagName: "span"
    }),
    value: 'NOT_LOADED'
  }]; // focus filter input when according tab is selected, for selection lists this is done automatically

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      activeTab = _useState6[0],
      setActiveTab = _useState6[1];

  (0, _react.useEffect)(function () {
    switch (activeTab) {
      case 'name':
        {
          nameInput.current.focus();
          break;
        }

      case 'externalId':
        {
          externalIdInput.current.focus();
          break;
        }

      case 'customerName':
        {
          customerNameInput.current.focus();
          break;
        }

      case 'railwayUndertaking':
        {
          railwayUndertakingInput.current.focus();
          break;
        }

      case 'externalProjectReference':
        {
          externalProjectReferenceInput.current.focus();
          break;
        }

      default:
    }
  }, [activeTab]); // filter data

  var _useMemo = (0, _react.useMemo)(function () {
    return makeFilter({
      assetIds: assetFilter.selectedRows.length > 0 && !assetFilter.isAllSelected ? assetFilter.selectedRows : null,
      startWayPointId: startWayPointId.selectedRows.length > 0 && !startWayPointId.isAllSelected ? startWayPointId.selectedRows : null,
      endWayPointId: endWayPointId.selectedRows.length > 0 && !endWayPointId.isAllSelected ? endWayPointId.selectedRows : null,
      linkedPortals: linkedPortalsFilter.selectedRows.length > 0 && !linkedPortalsFilter.isAllSelected ? linkedPortalsFilter.selectedRows : null,
      name: debouncedName || null,
      externalId: debouncedExternalId || null,
      externalProjectReference: debouncedExternalProjectReference || null,
      tourStatus: filters.values.tourStatus,
      startDate: {
        from: startDateFilter.inputValue.from || null,
        until: startDateFilter.inputValue.until || null
      },
      endDate: {
        from: endDateFilter.inputValue.from || null,
        until: endDateFilter.inputValue.until || null
      },
      isMine: isMine.selectedRows.length === 1 ? isMine.selectedRows[0] : null,
      projectIds: projectsFilter.selectedRows.length > 0 && !projectsFilter.isAllSelected ? projectsFilter.selectedRows : null,
      portalId: portalId,
      // rail
      customerName: debouncedCustomerName || null,
      railwayUndertaking: debouncedRailwayUndertaking || null,
      loaded: loadedFilter.selectedRows.length > 0 ? loadedFilter.selectedRows : null
    });
  }, [assetFilter.isAllSelected, assetFilter.selectedRows, debouncedCustomerName, debouncedExternalId, debouncedExternalProjectReference, debouncedName, debouncedRailwayUndertaking, endDateFilter.inputValue.from, endDateFilter.inputValue.until, endWayPointId.isAllSelected, endWayPointId.selectedRows, filters.values.tourStatus, isMine.selectedRows, linkedPortalsFilter.isAllSelected, linkedPortalsFilter.selectedRows, loadedFilter.selectedRows, portalId, projectsFilter.isAllSelected, projectsFilter.selectedRows, startDateFilter.inputValue.from, startDateFilter.inputValue.until, startWayPointId.isAllSelected, startWayPointId.selectedRows]),
      filterTree = _useMemo.filterTree;

  (0, _react.useEffect)(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      getAlarmInformationListFromBackend(portalId);
      getPoisFromBackend(portalId);
      getLinkedPortalsInformationListFromBackend(portalId);
    }
  }, [getAlarmInformationListFromBackend, getLinkedPortalsInformationListFromBackend, getPoisFromBackend, portalId]); // request to load the transport tours

  var _useInfiniteQuery = (0, _reactQuery.useInfiniteQuery)(['tourboard.tour.data', {
    portalId: portalId,
    id: id,
    filterTree: filterTree,
    sortDirection: state.sortDirection,
    sortBy: state.sortBy
  }], /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref18) {
      var _ref18$pageParam, pageParam, _yield$request3, body;

      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _ref18$pageParam = _ref18.pageParam, pageParam = _ref18$pageParam === void 0 ? 0 : _ref18$pageParam;
              _context8.next = 3;
              return request(getTours(portalId, id, filterTree, {
                pageNumber: pageParam,
                pageSize: PAGE_SIZE
              }, [{
                sortOrder: state.sortDirection,
                attributeName: state.sortBy
              }]));

            case 3:
              _yield$request3 = _context8.sent;
              body = _yield$request3.body;
              return _context8.abrupt("return", body);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref19.apply(this, arguments);
    };
  }(), {
    getNextPageParam: function getNextPageParam(lastPage, allPages) {
      var _lastPage$tours;

      if ((lastPage === null || lastPage === void 0 ? void 0 : (_lastPage$tours = lastPage.tours) === null || _lastPage$tours === void 0 ? void 0 : _lastPage$tours.length) === PAGE_SIZE) {
        return allPages.length;
      }

      return undefined;
    },
    select: (0, _react.useCallback)(function (_ref20) {
      var _pages;

      var pages = _ref20.pages;
      return {
        count: (_pages = pages[pages.length - 1]) === null || _pages === void 0 ? void 0 : _pages.filteredCount,
        rowData: pages.map(function (page) {
          return page.tours;
        }).flat()
      };
    }, []),
    refetchInterval: 60000
  }),
      isLoadingTours = _useInfiniteQuery.isLoading,
      _useInfiniteQuery$dat = _useInfiniteQuery.data;

  _useInfiniteQuery$dat = _useInfiniteQuery$dat === void 0 ? {} : _useInfiniteQuery$dat;
  var _useInfiniteQuery$dat2 = _useInfiniteQuery$dat.rowData,
      rowData = _useInfiniteQuery$dat2 === void 0 ? [] : _useInfiniteQuery$dat2,
      _useInfiniteQuery$dat3 = _useInfiniteQuery$dat.count,
      count = _useInfiniteQuery$dat3 === void 0 ? 0 : _useInfiniteQuery$dat3,
      fetchNextPage = _useInfiniteQuery.fetchNextPage,
      hasNextPage = _useInfiniteQuery.hasNextPage; // request to create the tour

  var _useMutation = (0, _reactQuery.useMutation)( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tour) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", request({
                type: 'CREATE_TOUR_FOR_TOUR_BOARD_REQUEST',
                headers: {
                  version: 'v1',
                  portalId: portalId
                },
                body: {
                  tour: tour
                }
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries('tourboard.tour.data', {
        portalId: portalId,
        id: id,
        filterTree: filterTree,
        sortDirection: state.sortDirection,
        sortBy: state.sortBy
      });
    }
  }),
      createTour = _useMutation.mutateAsync; // request to update the tour


  var _useMutation2 = (0, _reactQuery.useMutation)( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(tour) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", request({
                type: 'UPDATE_TOUR_FOR_TOUR_BOARD_REQUEST',
                headers: {
                  version: 'v1',
                  portalId: portalId
                },
                body: {
                  tour: tour
                }
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries('tourboard.tour.data', {
        portalId: portalId,
        id: id,
        filterTree: filterTree,
        sortDirection: state.sortDirection,
        sortBy: state.sortBy
      });
    }
  }),
      updateTour = _useMutation2.mutateAsync; // request to delete the tour


  var _useMutation3 = (0, _reactQuery.useMutation)( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(tourIdToDelete) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", request({
                type: 'DELETE_TOUR_FOR_TOUR_BOARD_REQUEST',
                headers: {
                  version: 'v1',
                  portalId: portalId
                },
                body: {
                  tour: {
                    id: tourIdToDelete
                  }
                }
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }(), {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries('tourboard.tour.data', {
        portalId: portalId,
        id: id,
        filterTree: filterTree,
        sortDirection: state.sortDirection,
        sortBy: state.sortBy
      });
    }
  }),
      deleteTour = _useMutation3.mutateAsync; // request to start the tour


  var _useMutation4 = (0, _reactQuery.useMutation)( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(tourIdToStart) {
      var _yield$request, tours;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return request({
                type: 'MANUAL_START_TOUR_FOR_TOUR_BOARD_REQUEST',
                headers: {
                  version: 'v1',
                  portalId: portalId
                },
                body: {
                  tour: {
                    id: tourIdToStart
                  }
                }
              });

            case 2:
              _yield$request = _context4.sent;
              tours = _yield$request.body.tours;
              return _context4.abrupt("return", tours);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }(), {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries('tourboard.tour.data', {
        portalId: portalId,
        id: id,
        filterTree: filterTree,
        sortDirection: state.sortDirection,
        sortBy: state.sortBy
      });
    }
  }),
      startTour = _useMutation4.mutateAsync; // request to terminate the tour


  var _useMutation5 = (0, _reactQuery.useMutation)( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(tourIdToTerminate) {
      var _yield$request2, tours;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return request({
                type: 'TERMINATE_TOUR_FOR_TOUR_BOARD_REQUEST',
                headers: {
                  version: 'v1',
                  portalId: portalId
                },
                body: {
                  tour: {
                    id: tourIdToTerminate
                  }
                }
              });

            case 2:
              _yield$request2 = _context5.sent;
              tours = _yield$request2.body.tours;
              return _context5.abrupt("return", tours);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref7.apply(this, arguments);
    };
  }(), {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries('tourboard.tour.data', {
        portalId: portalId,
        id: id,
        filterTree: filterTree,
        sortDirection: state.sortDirection,
        sortBy: state.sortBy
      });
    }
  }),
      terminateTour = _useMutation5.mutateAsync; // request to assign an asset to a tour


  var _useMutation6 = (0, _reactQuery.useMutation)(function (_ref8) {
    var tourId = _ref8.tourId,
        assetId = _ref8.assetId,
        assetType = _ref8.assetType;
    return request(assignAssetToTour(tourId, assetId, assetType, portalId));
  }, {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries('tourboard.tour.data', {
        portalId: portalId,
        id: id,
        filterTree: filterTree,
        sortDirection: state.sortDirection,
        sortBy: state.sortBy
      });
    }
  }),
      assignAsset = _useMutation6.mutateAsync;

  var _useMutation7 = (0, _reactQuery.useMutation)( /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(exportColumns) {
      var sortDirection, sortBy, currentPageNumber, dynamicSorters, dynamicPaging;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              sortDirection = state.sortDirection, sortBy = state.sortBy, currentPageNumber = state.currentPageNumber;
              dynamicSorters = [{
                sortOrder: sortDirection,
                attributeName: sortBy
              }];
              dynamicPaging = {
                pageNumber: currentPageNumber,
                pageSize: PAGE_SIZE
              };
              return _context6.abrupt("return", request(createTourBoardExport(portalId, filterTree, dynamicSorters, dynamicPaging, exportColumns.map(function (column) {
                return column.dataKey;
              }))));

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref9.apply(this, arguments);
    };
  }()),
      createExcelExport = _useMutation7.mutateAsync;

  var _usePortalSystemExcha = (0, _hooks.usePortalSystemExchangeProjects)(portalId, {
    select: function select(projects) {
      return projects.sort(function (a, b) {
        return a.projectName > b.projectName ? 1 : -1;
      }).map(function (project) {
        return {
          label: project.projectName,
          value: project.id
        };
      });
    }
  }),
      systemExchangeProjects = _usePortalSystemExcha.data,
      isLoadingProjects = _usePortalSystemExcha.isLoading;

  var onNewTourButtonClicked = function onNewTourButtonClicked() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isEditTourPopupActive: true,
        tourToEdit: getDefaultTourObject(user, settings === null || settings === void 0 ? void 0 : settings.tourDefaults)
      });
    });
  };

  var onNewRailTour = function onNewRailTour() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isRailDialogOpen: true,
        tourToEdit: getDefaultTourObject(user, settings === null || settings === void 0 ? void 0 : settings.tourDefaults)
      });
    });
  };

  var onEditClicked = (0, _react.useCallback)(function (tourId) {
    var tourObject = rowData === null || rowData === void 0 ? void 0 : rowData.find(function (tour) {
      return tour.id === tourId;
    });

    if (tourObject) {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          isEditTourPopupActive: hasPermissions(['module.tour.road']),
          isRailDialogOpen: hasPermissions(['module.tour.rail']),
          // use the default object as a base, to make sure all properties and arrays are initialised
          tourToEdit: _objectSpread(_objectSpread({}, getDefaultTourObject(user, settings === null || settings === void 0 ? void 0 : settings.tourDefaults)), tourObject)
        });
      });
    }
  }, [hasPermissions, rowData, settings.tourDefaults, user]);
  var onDetailsClick = (0, _react.useCallback)(function (tourId) {
    var tourObject = rowData === null || rowData === void 0 ? void 0 : rowData.find(function (tour) {
      return tour.id === tourId;
    });

    if (tourObject) {
      var tourToEdit = _objectSpread(_objectSpread({}, getDefaultTourObject(user, settings === null || settings === void 0 ? void 0 : settings.tourDefaults)), tourObject);

      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          isDetailsPopupActive: true,
          // use the default object as a base, to make sure all properties and arrays are initialised
          tourToEdit: tourToEdit
        });
      });
    }
  }, [rowData, settings.tourDefaults, user]);
  var onTerminateClicked = (0, _react.useCallback)(function (tourId) {
    terminateTour(tourId);
  }, [terminateTour]);
  var onAssetRequestActive = (0, _react.useCallback)(function (value) {
    var tourObject = rowData === null || rowData === void 0 ? void 0 : rowData.find(function (tour) {
      return tour.id === value;
    });

    if (tourObject) {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          isAssetRequestPopupActive: true,
          tourToAssetRequest: _objectSpread(_objectSpread({}, getDefaultTourObject(user, settings === null || settings === void 0 ? void 0 : settings.tourDefaults)), tourObject)
        });
      });
    }
  }, [rowData, settings.tourDefaults, user]);

  var onAssetRequestClosed = function onAssetRequestClosed() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isAssetRequestPopupActive: false
      });
    });
  };

  var onStartClicked = (0, _react.useCallback)(function (tourId) {
    startTour(tourId);
  }, [startTour]);
  var onDeleteClicked = (0, _react.useCallback)(function (tourId) {
    deleteTour(tourId);
  }, [deleteTour]);

  var onEditTourDialogClosed = function onEditTourDialogClosed() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isEditTourPopupActive: false
      });
    });
  };

  var onRailDialogClosed = function onRailDialogClosed() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isRailDialogOpen: false
      });
    });
  };

  var onDetailsDialogClosed = function onDetailsDialogClosed() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isDetailsPopupActive: false
      });
    });
  };

  var onNewTourSaved = (0, _react.useCallback)(function (tour) {
    createTour(tour);
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isEditTourPopupActive: false,
        isRailDialogOpen: false
      });
    });
  }, [createTour]);
  var onTourUpdated = (0, _react.useCallback)(function (tour) {
    // todo: remove deletion of projectIds when BE no longer includes it in the FIND_TOURS API
    var updatedTour = _objectSpread({}, tour);

    delete updatedTour.projectIds;
    updateTour(updatedTour);
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isEditTourPopupActive: false,
        isRailDialogOpen: false
      });
    });
  }, [updateTour]);
  var onColumnReorder = (0, _react.useCallback)(function (_ref10) {
    var oldIndex = _ref10.oldIndex,
        newIndex = _ref10.newIndex;

    if (oldIndex === newIndex) {
      return;
    }

    var orderedColumns = [].concat(_toConsumableArray(visibleColumns.slice(0, oldIndex)), _toConsumableArray(visibleColumns.slice(oldIndex + 1)));
    orderedColumns.splice(newIndex, 0, visibleColumns[oldIndex]);
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        tempSettings: _objectSpread(_objectSpread({}, prev.tempSettings), {}, {
          visibleColumns: orderedColumns
        })
      });
    });
    updateSettings(id, _objectSpread(_objectSpread({}, settings), {
      columns: orderedColumns
    }), portalId);
  }, [id, portalId, settings, updateSettings, visibleColumns]);
  var onColumnResize = (0, _react.useCallback)(function (_ref11) {
    var dataKey = _ref11.dataKey,
        width = _ref11.width;
    var cols = visibleColumns.map(function (col) {
      if (col.dataKey === dataKey) {
        return _objectSpread(_objectSpread({}, col), {
          width: width
        });
      }

      return col;
    });
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        tempSettings: _objectSpread(_objectSpread({}, state.tempSettings), {}, {
          visibleColumns: cols
        })
      });
    });
    updateSettings(id, _objectSpread(_objectSpread({}, settings), {
      columns: cols
    }), portalId);
  }, [id, portalId, settings, state.tempSettings, updateSettings, visibleColumns]);

  var onColumnSort = function onColumnSort(_ref12) {
    var sortBy = _ref12.sortBy,
        sortDirection = _ref12.sortDirection;

    if (_columnDefinition.columnDefinition[sortBy].sortable) {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          sortBy: sortBy,
          sortDirection: sortDirection
        });
      });
    }
  };

  var onToggleColumnVisibility = function onToggleColumnVisibility(_ref13) {
    var dataKey = _ref13.dataKey,
        visible = _ref13.visible;
    var toggleColumns = state.tempSettings.visibleColumns;
    var column = {
      dataKey: dataKey
    };

    if (visible) {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          tempSettings: {
            visibleColumns: [].concat(_toConsumableArray(toggleColumns), [column])
          }
        });
      });
    } else {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          tempSettings: {
            visibleColumns: toggleColumns.filter(function (col) {
              return col.dataKey !== dataKey;
            })
          }
        });
      });
    }
  };

  var onSettingsSave = function onSettingsSave() {
    var updatedColumns = state.tempSettings.visibleColumns;
    updateSettings(id, _objectSpread(_objectSpread({}, settings), {
      columns: updatedColumns
    }), portalId);
  };

  var onRowClick = (0, _react.useCallback)(function (_ref14) {
    var selectedData = _ref14.rowData;

    if (selectedData.id && selectedData.id !== state.selectedTour) {
      var dataId = selectedData.id,
          assetId = selectedData.assetId,
          startDate = selectedData.realStartTime,
          endDate = selectedData.realEndTime;
      var from = state.from,
          until = state.until;
      var values = filters.values;
      var tourStatus = values.tourStatus;
      var waiting = tourStatus.waiting,
          requested = tourStatus.requested,
          received = tourStatus.received;
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          selectedTour: dataId
        });
      });
      var eventProps = {
        assetId: assetId,
        tourId: dataId
      };

      if (selectedData.status === _constants.TOUR_STATUS.FINISHED) {
        eventProps = _objectSpread(_objectSpread({}, eventProps), {}, {
          startDate: startDate,
          endDate: endDate
        });
        getTourAlarms(portalId, id, eventProps);
      }

      if (selectedData.status === _constants.TOUR_STATUS.RUNNING) {
        eventProps = _objectSpread(_objectSpread({}, eventProps), {}, {
          startDate: startDate,
          endDate: new Date().toISOString()
        });
        getTourAlarms(portalId, id, eventProps);
      }

      if (waiting || requested || received) {
        emitConnectEvent({
          assetId: null,
          startDate: from,
          endDate: until
        });
      }

      emitConnectEvent(eventProps);
    } else {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          selectedTour: null
        });
      });
      emitConnectEvent({
        assetId: null,
        tourId: null
      });
    }
  }, [emitConnectEvent, filters, getTourAlarms, id, portalId, state]);

  var onIntelligentCopyDialogClosed = function onIntelligentCopyDialogClosed() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isIntelligentCopyPopupActive: false
      });
    });
  };

  var onReportExportDialogClosed = function onReportExportDialogClosed() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isReportExportPopupActive: false
      });
    });
  };

  var onTourCopy = function onTourCopy(copiedTour) {
    createTour(copiedTour);
    onIntelligentCopyDialogClosed();
  };

  var onReportExport = function onReportExport(tourToExport) {
    exportTourReport(portalId, tourToExport);
    onReportExportDialogClosed();
  };

  var onReportExportClicked = (0, _react.useCallback)(function (tourId) {
    var tourObject = rowData === null || rowData === void 0 ? void 0 : rowData.find(function (tour) {
      return tour.id === tourId;
    });

    if (tourObject) {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          isReportExportPopupActive: true,
          // use the default object as a base, to make sure all properties and arrays are initialised
          tourToExport: Object.assign(getDefaultTourObject(user, settings === null || settings === void 0 ? void 0 : settings.tourDefaults), tourObject, {
            report: _objectSpread(_objectSpread({}, tourObject.report), {}, {
              recipients: [user.email]
            })
          })
        });
      });
    }
  }, [rowData, settings.tourDefaults, user]);

  var onAssetRequestHandler = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(assetId) {
      var _assets$find;

      var assetType;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              assetType = ((_assets$find = assets.find(function (asset) {
                return asset.id === assetId;
              })) === null || _assets$find === void 0 ? void 0 : _assets$find.type) || null;
              _context7.next = 3;
              return assignAsset({
                tourId: state.tourToAssetRequest.id,
                assetId: assetId,
                assetType: assetType
              });

            case 3:
              onAssetRequestClosed();

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function onAssetRequestHandler(_x7) {
      return _ref15.apply(this, arguments);
    };
  }();

  var onCreateExport = function onCreateExport(exportColumns) {
    if (count <= EXPORT_LIMIT) {
      createExcelExport(exportColumns);
    } else {
      // trigger toast
      dispatch({
        type: 'CREATE_TOUR_BOARD_EXPORT_LIMIT_ERROR',
        body: {}
      });
    }
  };

  var onExportTransportOrderClick = (0, _react.useCallback)(function (tourId) {
    onExportDispatch({
      tourId: tourId,
      portalId: portalId
    });
  }, [onExportDispatch, portalId]);
  var useAsTemplate = (0, _react.useCallback)(function (tourId) {
    var tourObject = rowData === null || rowData === void 0 ? void 0 : rowData.find(function (tour) {
      return tour.id === tourId;
    });

    if (tourObject) {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          isIntelligentCopyPopupActive: true,
          tourToCopy: _objectSpread(_objectSpread({}, getDefaultTourObject(user, settings === null || settings === void 0 ? void 0 : settings.tourDefaults)), tourObject)
        });
      });
    }
  }, [rowData, settings.tourDefaults, user]);

  var updateStatusToggleFilter = function updateStatusToggleFilter(updatedValue) {
    var newStatusFilter = _objectSpread(_objectSpread({}, filters.values.tourStatus), updatedValue);

    var filtersToUpdate = {
      tourStatus: newStatusFilter
    }; // reset date filter if not running tab

    if (newStatusFilter.waiting || newStatusFilter.running) {
      filtersToUpdate.date = null;
    }

    var from = state.from,
        until = state.until;

    if (newStatusFilter.waiting || newStatusFilter.received || newStatusFilter.requested) {
      emitConnectEvent({
        assetId: null,
        startDate: from,
        endDate: until
      });
    }

    filters.update(filtersToUpdate); // also save the changes in the widgets settings

    updateSettings(id, _objectSpread(_objectSpread({}, settings), filtersToUpdate), portalId);
  };

  var selectedTour = state.selectedTour,
      tempSettings = state.tempSettings; // add tour alarm to selected tour

  var sortedRows = _toConsumableArray(rowData !== null && rowData !== void 0 ? rowData : []).map(function (tour) {
    if (tour.id === selectedTour && tour.status !== _constants.TOUR_STATUS.WAITING) {
      return _objectSpread(_objectSpread({}, tour), {}, {
        activatedAlarms: tourAlarms.filter(function (alarm) {
          return tour.generatedAlarmIds.includes(alarm.id);
        })
      });
    }

    return tour;
  });

  var tempVisibleColumns = tempSettings.visibleColumns;

  var isStartDateEnabled = function isStartDateEnabled(endDate) {
    return function (_ref16) {
      var dateToCheck = _ref16.dateToCheck;
      return !endDate ? true : dateToCheck <= new Date(endDate);
    };
  };

  var isEndDateEnabled = function isEndDateEnabled(startDate) {
    return function (_ref17) {
      var dateToCheck = _ref17.dateToCheck;
      return !startDate ? true : dateToCheck >= new Date(startDate);
    };
  };

  var isMineData = [{
    value: 1,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.ownTour",
      tagName: "span"
    })
  }, {
    value: 0,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.otherTour",
      tagName: "span"
    })
  }];
  var formattedStartDateFrom = startDateFilter.inputValue.from && (0, _momentTimezone["default"])(startDateFilter.inputValue.from).locale(user.locale).format('L');
  var formattedStartDateUntil = startDateFilter.inputValue.until && (0, _momentTimezone["default"])(startDateFilter.inputValue.until).locale(user.locale).format('L');
  var formattedEndDateFrom = endDateFilter.inputValue.from && (0, _momentTimezone["default"])(endDateFilter.inputValue.from).locale(user.locale).format('L');
  var formattedEndDateUntil = endDateFilter.inputValue.until && (0, _momentTimezone["default"])(endDateFilter.inputValue.until).locale(user.locale).format('L');
  var filterCount = [formattedStartDateFrom ? 1 : 0, formattedStartDateUntil ? 1 : 0, formattedEndDateFrom ? 1 : 0, formattedEndDateUntil ? 1 : 0, assetFilter.selectedRows.length, startWayPointId.selectedRows.length, endWayPointId.selectedRows.length, isMine.selectedRows.length, filters.values.externalId ? 1 : 0, filters.values.name ? 1 : 0, filters.values.externalProjectReference ? 1 : 0, linkedPortalsFilter.selectedRows.length, filters.values.customerName ? 1 : 0, filters.values.railwayUndertaking ? 1 : 0, loadedFilter.selectedRows.length, projectsFilter.selectedRows.length].reduce(function (result, current) {
    return result + current;
  }, 0);
  var showFilterContainer = filterCount > 0;
  var memorizedEditTourComponent = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_roadTourComponent["default"], {
      key: "editTourPopup",
      portalId: portalId,
      onCancel: onEditTourDialogClosed,
      isActive: true,
      isNewTour: state.tourToEdit.id === undefined,
      isShareTour: Object.keys(linkedPortals).length > 0 && hasPermissions(['module.tour.road']) && hasPermissions(['module.tour.extended']),
      onSave: onNewTourSaved,
      onUpdate: onTourUpdated,
      tour: state.tourToEdit,
      assets: assets,
      alarms: alarms,
      linkedPortals: linkedPortals
    });
  }, [alarms, assets, linkedPortals, onNewTourSaved, onTourUpdated, portalId, state.tourToEdit, hasPermissions]);
  var memorizedRailTourComponent = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_railTourComponent["default"], {
      key: "railDialog",
      onCancel: onRailDialogClosed,
      isActive: true,
      onSave: onNewTourSaved,
      onUpdate: onTourUpdated,
      tour: state.tourToEdit,
      alarms: alarms,
      portalId: portalId
    });
  }, [alarms, onNewTourSaved, onTourUpdated, portalId, state.tourToEdit]);
  var memorizedTable = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_tourBoardTable["default"], {
      saveTableRef: function saveTableRef(ref) {
        tableRef.current = ref;
      },
      onPageChange: function onPageChange() {
        if (hasNextPage) {
          fetchNextPage();
        }
      },
      onRowClick: onRowClick,
      onEditClicked: onEditClicked,
      onDetailsClick: onDetailsClick,
      useAsTemplate: useAsTemplate,
      onExportTransportOrderClick: onExportTransportOrderClick,
      onReportExportClicked: onReportExportClicked,
      onTerminateClicked: onTerminateClicked,
      onAssetRequestClick: onAssetRequestActive,
      onStartClicked: onStartClicked,
      onDeleteClicked: onDeleteClicked,
      data: sortedRows,
      count: count,
      visibleColumns: visibleColumns,
      selectedTour: state.selectedTour,
      onColumnReorder: onColumnReorder,
      onColumnResize: onColumnResize,
      onColumnSort: onColumnSort,
      sortDirection: state.sortDirection,
      sortBy: state.sortBy,
      tourStatus: filters.values.tourStatus
    });
  }, [onRowClick, onEditClicked, onDetailsClick, useAsTemplate, onExportTransportOrderClick, onReportExportClicked, onTerminateClicked, onAssetRequestActive, onStartClicked, onDeleteClicked, sortedRows, count, visibleColumns, state.selectedTour, state.sortDirection, state.sortBy, onColumnReorder, onColumnResize, filters.values.tourStatus, hasNextPage, fetchNextPage]);

  var renderDialogs = function renderDialogs() {
    var isNewTour = state.tourToEdit.id === undefined;

    if (isNewTour) {
      if (state.isRailDialogOpen) {
        return memorizedRailTourComponent;
      }

      if (state.isEditTourPopupActive) {
        return memorizedEditTourComponent;
      }
    } else {
      var _state$tourToEdit, _state$tourToEdit2, _state$tourToEdit2$ad, _state$tourToEdit3, _state$tourToEdit3$da, _state$tourToEdit4;

      if (state.isRailDialogOpen && ((0, _mapping.isRailAsset)((_state$tourToEdit = state.tourToEdit) === null || _state$tourToEdit === void 0 ? void 0 : _state$tourToEdit.assetType) || (_state$tourToEdit2 = state.tourToEdit) !== null && _state$tourToEdit2 !== void 0 && (_state$tourToEdit2$ad = _state$tourToEdit2.additionalData) !== null && _state$tourToEdit2$ad !== void 0 && _state$tourToEdit2$ad.railInfo && ((_state$tourToEdit3 = state.tourToEdit) === null || _state$tourToEdit3 === void 0 ? void 0 : (_state$tourToEdit3$da = _state$tourToEdit3.dataRequest) === null || _state$tourToEdit3$da === void 0 ? void 0 : _state$tourToEdit3$da.type) === 'PORTAL')) {
        return memorizedRailTourComponent;
      }

      if (state.isEditTourPopupActive && !(0, _mapping.isRailAsset)((_state$tourToEdit4 = state.tourToEdit) === null || _state$tourToEdit4 === void 0 ? void 0 : _state$tourToEdit4.assetType)) {
        return memorizedEditTourComponent;
      }
    }

    return null;
  };

  return /*#__PURE__*/_react["default"].createElement(_nicbaseWidgetUtils.BaseWidget, {
    id: id,
    portalId: portalId,
    connectionDisabled: true,
    className: "tour-board-widget",
    isEditActive: isEditActive,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.title",
      tagName: "span"
    }),
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.TourBoard, {
      className: "inline-block"
    }),
    settings: hasPermissions(['module.tour.extended']) ? /*#__PURE__*/_react["default"].createElement(_settings["default"], {
      portalId: portalId,
      onToggleColumn: onToggleColumnVisibility,
      visibleColumns: tempVisibleColumns,
      settings: settings
    }) : null,
    settingsLabel: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.settings.title",
      tagName: "span"
    }),
    onSettingsSave: onSettingsSave
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col flex-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex mb-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex items-center relative mr-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "".concat(id, "waitingToggle"),
    className: "cursor-pointer flex"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "hidden",
    id: "".concat(id, "waitingToggle"),
    type: "checkbox",
    checked: filters.values.tourStatus.waiting,
    onChange: function onChange() {
      updateStatusToggleFilter({
        running: false,
        finished: false,
        waiting: true,
        received: false,
        requested: false
      });
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          sortBy: 'plannedStartTime',
          sortDirection: 'DESC'
        });
      });
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('flex-1 inline-block text-center rounded p-3', {
      'bg-gray-200': (_filters$values$tourS = filters.values.tourStatus) === null || _filters$values$tourS === void 0 ? void 0 : _filters$values$tourS.waiting
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.waiting"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex items-center relative mr-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "cursor-pointer flex"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "hidden",
    id: "".concat(id, "runningToggle"),
    type: "checkbox",
    checked: filters.values.tourStatus.running,
    onChange: function onChange() {
      updateStatusToggleFilter({
        running: true,
        finished: false,
        waiting: false,
        received: false,
        requested: false
      });
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          sortBy: 'realStartTime',
          sortDirection: 'DESC'
        });
      });
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('flex-1 inline-block text-center rounded p-3', {
      'bg-gray-200': (_filters$values$tourS2 = filters.values.tourStatus) === null || _filters$values$tourS2 === void 0 ? void 0 : _filters$values$tourS2.running
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.running"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex items-center relative mr-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "cursor-pointer flex"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "hidden",
    id: "".concat(id, "finishedToggle"),
    type: "checkbox",
    checked: filters.values.tourStatus.finished,
    onChange: function onChange() {
      updateStatusToggleFilter({
        running: false,
        finished: true,
        waiting: false,
        received: false,
        requested: false
      });
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          sortBy: 'realStartTime',
          sortDirection: 'DESC'
        });
      });
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('flex-1 inline-block text-center rounded p-3', {
      'bg-gray-200': (_filters$values$tourS3 = filters.values.tourStatus) === null || _filters$values$tourS3 === void 0 ? void 0 : _filters$values$tourS3.finished
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.finished"
  })))), Object.keys(linkedPortals).length > 0 && hasPermissions(['module.tour.dataRequest.columns']) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex items-center relative mr-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "cursor-pointer flex"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "hidden",
    id: "".concat(id, "receivedDataRequestToggle"),
    type: "checkbox",
    checked: filters.values.tourStatus.received,
    onChange: function onChange() {
      updateStatusToggleFilter({
        running: false,
        finished: false,
        waiting: false,
        received: true,
        requested: false
      });
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          sortBy: 'plannedStartTime',
          sortDirection: 'DESC'
        });
      });
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('flex-1 inline-block text-center rounded p-3', {
      'bg-gray-200': (_filters$values$tourS4 = filters.values.tourStatus) === null || _filters$values$tourS4 === void 0 ? void 0 : _filters$values$tourS4.received
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.received"
  })))), Object.keys(linkedPortals).length > 0 && hasPermissions(['module.tour.dataRequest.columns']) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex items-center relative mr-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "cursor-pointer flex"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "hidden",
    id: "".concat(id, "requestedDataRequestToggle"),
    type: "checkbox",
    checked: filters.values.tourStatus.requested,
    onChange: function onChange() {
      updateStatusToggleFilter({
        running: false,
        finished: false,
        waiting: false,
        received: false,
        requested: true
      });
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          sortBy: 'plannedStartTime',
          sortDirection: 'DESC'
        });
      });
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('flex-1 inline-block text-center rounded p-3', {
      'bg-gray-200': (_filters$values$tourS5 = filters.values.tourStatus) === null || _filters$values$tourS5 === void 0 ? void 0 : _filters$values$tourS5.requested
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.requested"
  }))))), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterContainer, {
    id: id,
    responsiveMode: responsiveMode.mode,
    isMobile: state.isMobile,
    hasActiveFilters: !!filters.values
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterFlyOut, {
    badgeCount: filterCount > 0 ? filterCount : null,
    useOutsideClick: outsideClick,
    onTabChange: function onTabChange(tabId) {
      return setActiveTab(tabId);
    },
    onReset: function onReset() {
      assetFilter.onReset();
      startWayPointId.onReset();
      endWayPointId.onReset();
      startDateFilter.onInputChange({});
      endDateFilter.onInputChange({});
      linkedPortalsFilter.onReset();
      isMine.onReset();
      loadedFilter.onReset();
      projectsFilter.onReset();
      filters.update({
        name: '',
        externalId: '',
        externalProjectReference: '',
        customerName: '',
        railwayUndertaking: ''
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "name",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.name"
    }),
    badgeCount: filters.values.name && 1,
    onReset: function onReset() {
      return filters.update({
        name: ''
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-2 flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterInput, {
    value: filters.values.name,
    onChange: function onChange(name) {
      return filters.update({
        name: name
      });
    },
    ref: nameInput
  }))), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "externalId",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.externalId"
    }),
    badgeCount: filters.values.externalId && 1,
    onReset: function onReset() {
      return filters.update({
        externalId: ''
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-2 flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterInput, {
    value: filters.values.externalId,
    onChange: function onChange(externalId) {
      return filters.update({
        externalId: externalId
      });
    },
    ref: externalIdInput
  }))), hasPermissions(['module.tour.rail']) ? [/*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "assets",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.train"
    }),
    badgeCount: assetFilter.selectedRows.length,
    onReset: assetFilter.onReset
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterableAssetSelectionList, _extends({
    hideSelectAll: true,
    onlyCoupledAssets: true,
    showHistoricalAssets: true,
    className: "flex-1"
  }, assetFilter))), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "customerName",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.customerName"
    }),
    badgeCount: filters.values.customerName && 1,
    onReset: function onReset() {
      return filters.update({
        customerName: ''
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-2 flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterInput, {
    value: filters.values.customerName,
    onChange: function onChange(customerName) {
      return filters.update({
        customerName: customerName
      });
    },
    ref: customerNameInput
  }))), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "railwayUndertaking",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.railwayUndertaking"
    }),
    badgeCount: filters.values.railwayUndertaking && 1,
    onReset: function onReset() {
      return filters.update({
        railwayUndertaking: ''
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-2 flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterInput, {
    value: filters.values.railwayUndertaking,
    onChange: function onChange(railwayUndertaking) {
      return filters.update({
        railwayUndertaking: railwayUndertaking
      });
    },
    ref: railwayUndertakingInput
  }))), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "loaded",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.loadedStatus"
    }),
    badgeCount: loadedFilter.selectedRows.length,
    onReset: loadedFilter.onReset
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterableSelectionList, _extends({
    hideSelectAll: true,
    className: "flex-1"
  }, loadedFilter, {
    data: loadedTypes
  })))] : /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "assets",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.asset"
    }),
    badgeCount: assetFilter.selectedRows.length,
    onReset: assetFilter.onReset
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterableAssetSelectionList, _extends({
    hideSelectAll: true,
    showHistoricalAssets: true,
    hideCoupledAssets: true,
    className: "flex-1"
  }, assetFilter))), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "startWayPointId",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.startWayPointId"
    }),
    badgeCount: startWayPointId.selectedRows.length,
    onReset: startWayPointId.onReset
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterablePOISelectionList, _extends({
    hideSelectAll: true,
    hideServiceStations: true,
    className: "flex-1"
  }, startWayPointId))), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "endWayPointId",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.endWayPointId"
    }),
    badgeCount: endWayPointId.selectedRows.length,
    onReset: endWayPointId.onReset
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterablePOISelectionList, _extends({
    hideSelectAll: true,
    hideServiceStations: true,
    className: "flex-1"
  }, endWayPointId))), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    badgeCount: Object.values(startDateFilter.inputValue).filter(function (value) {
      return value;
    }).length,
    onReset: function onReset() {
      return startDateFilter.onInputChange({});
    },
    id: "startDate",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.startDate"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-2",
    onMouseEnter: function onMouseEnter() {
      return setOutsideClick(false);
    },
    onMouseLeave: function onMouseLeave() {
      return setOutsideClick(true);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "tourBoard.filter.startDate"
  }), " ", /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "tourBoard.filter.startDate.from"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.DateFilter, {
    isFilterFlyOut: true,
    key: "".concat(startDateFilter.inputValue.from),
    isMobile: responsiveMode.mode === 'mobile',
    enabledDate: isStartDateEnabled(startDateFilter.inputValue.until),
    selectedDate: startDateFilter.inputValue.from,
    onChange: function onChange(from) {
      setOutsideClick(true);
      startDateFilter.onInputChange(_objectSpread(_objectSpread({}, startDateFilter.inputValue), {}, {
        from: from
      }));
    },
    inputLabel: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.datePicker.label"
    })
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "tourBoard.filter.startDate"
  }), " ", /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "tourBoard.filter.startDate.until"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.DateFilter, {
    className: "mt-1",
    isFilterFlyOut: true,
    isMobile: responsiveMode.mode === 'mobile',
    enabledDate: isEndDateEnabled(startDateFilter.inputValue.from),
    selectedDate: startDateFilter.inputValue.until,
    onChange: function onChange(until) {
      setOutsideClick(true);
      startDateFilter.onInputChange(_objectSpread(_objectSpread({}, startDateFilter.inputValue), {}, {
        until: until
      }));
    }
  })))), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    badgeCount: Object.values(endDateFilter.inputValue).filter(function (value) {
      return value;
    }).length,
    onReset: function onReset() {
      return endDateFilter.onInputChange({});
    },
    id: "endDate",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.endDate"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-2",
    onMouseEnter: function onMouseEnter() {
      return setOutsideClick(false);
    },
    onMouseLeave: function onMouseLeave() {
      return setOutsideClick(true);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "tourBoard.filter.endDate"
  }), " ", /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "tourBoard.filter.endDate.from"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.DateFilter, {
    isFilterFlyOut: true,
    key: "".concat(endDateFilter.inputValue.from),
    isMobile: responsiveMode.mode === 'mobile',
    enabledDate: isStartDateEnabled(endDateFilter.inputValue.until),
    selectedDate: endDateFilter.inputValue.from,
    onChange: function onChange(from) {
      setOutsideClick(true);
      endDateFilter.onInputChange(_objectSpread(_objectSpread({}, endDateFilter.inputValue), {}, {
        from: from
      }));
    },
    inputLabel: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.datePicker.label"
    })
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "tourBoard.filter.endDate"
  }), " ", /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "tourBoard.filter.endDate.until"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.DateFilter, {
    className: "mt-1",
    isFilterFlyOut: true,
    isMobile: responsiveMode.mode === 'mobile',
    enabledDate: isEndDateEnabled(endDateFilter.inputValue.from),
    selectedDate: endDateFilter.inputValue.until,
    onChange: function onChange(until) {
      setOutsideClick(true);
      endDateFilter.onInputChange(_objectSpread(_objectSpread({}, endDateFilter.inputValue), {}, {
        until: until
      }));
    }
  }))))), hasPermissions(['module.tour.road']) ? /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "linkedPortals",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.linkedPortals"
    }),
    badgeCount: linkedPortalsFilter.selectedRows.length,
    onReset: linkedPortalsFilter.onReset
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterableLinkedPortalsSelectionList, _extends({
    hideSelectAll: true,
    className: "flex-1"
  }, linkedPortalsFilter))) : null, hasPermissions(['module.tour.road']) ? /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "isMine",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.isMine"
    }),
    badgeCount: isMine.selectedRows.length,
    onReset: isMine.onReset
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterableSelectionList, _extends({
    hideSelectAll: true,
    className: "flex-1"
  }, isMine, {
    data: isMineData
  }))) : null, hasPermissions(['module.dcc.systemexchange.read']) && /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "projects",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.projects"
    }),
    badgeCount: projectsFilter.selectedRows.length,
    onReset: projectsFilter.onReset
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterableSelectionList, _extends({
    hideSelectAll: true,
    className: "flex-1"
  }, projectsFilter, {
    data: systemExchangeProjects
  }))), hasPermissions(['module.dcc.systemexchange.read']) && /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterTab, {
    id: "externalProjectReference",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.filter.externalProjectReference"
    }),
    badgeCount: filters.values.externalProjectReference && 1,
    onReset: function onReset() {
      return filters.update({
        externalProjectReference: ''
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-2 flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterInput, {
    value: filters.values.externalProjectReference,
    onChange: function onChange(externalProjectReference) {
      return filters.update({
        externalProjectReference: externalProjectReference
      });
    },
    ref: externalProjectReferenceInput
  })))), showFilterContainer && /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChipsContainer, {
    className: "flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterableAssetSelectionList.Chips, {
    selectedRows: assetFilter.selectedRows,
    onSelect: assetFilter.onSelect,
    showHistoricalAssets: true
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterablePOISelectionList.Chips, {
    selectedRows: startWayPointId.selectedRows,
    onSelect: startWayPointId.onSelect
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterablePOISelectionList.Chips, {
    selectedRows: endWayPointId.selectedRows,
    onSelect: endWayPointId.onSelect
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterableLinkedPortalsSelectionList.Chips, {
    selectedRows: linkedPortalsFilter.selectedRows,
    onSelect: linkedPortalsFilter.onSelect
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChips, {
    data: isMine.selectedRows.map(function (value) {
      return isMineData.find(function (mineId) {
        return mineId.value === value;
      });
    }),
    onSelect: isMine.onSelect
  }), ((_filters$values$name = filters.values.name) === null || _filters$values$name === void 0 ? void 0 : _filters$values$name.length) > 0 && /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChips, {
    data: [{
      value: '',
      label: filters.values.name
    }],
    onSelect: function onSelect(name) {
      return filters.update({
        name: name
      });
    }
  }), ((_filters$values$exter = filters.values.externalId) === null || _filters$values$exter === void 0 ? void 0 : _filters$values$exter.length) > 0 && /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChips, {
    data: [{
      value: '',
      label: filters.values.externalId
    }],
    onSelect: function onSelect(externalId) {
      return filters.update({
        externalId: externalId
      });
    }
  }), ((_filters$values$custo = filters.values.customerName) === null || _filters$values$custo === void 0 ? void 0 : _filters$values$custo.length) > 0 && /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChips, {
    data: [{
      value: '',
      label: filters.values.customerName
    }],
    onSelect: function onSelect(customerName) {
      return filters.update({
        customerName: customerName
      });
    }
  }), ((_filters$values$railw = filters.values.railwayUndertaking) === null || _filters$values$railw === void 0 ? void 0 : _filters$values$railw.length) > 0 && /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChips, {
    data: [{
      value: '',
      label: filters.values.railwayUndertaking
    }],
    onSelect: function onSelect(railwayUndertaking) {
      return filters.update({
        railwayUndertaking: railwayUndertaking
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChips, {
    onSelect: loadedFilter.onSelect,
    data: loadedFilter.selectedRows.map(function (value) {
      return loadedTypes.find(function (loadedType) {
        return loadedType.value === value;
      });
    })
  }), (formattedStartDateFrom === null || formattedStartDateFrom === void 0 ? void 0 : formattedStartDateFrom.length) > 0 && /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChips, {
    data: [{
      value: null,
      label: "".concat(intl.formatMessage({
        id: 'tourBoard.filter.startDate'
      }), " ").concat(intl.formatMessage({
        id: 'tourBoard.filter.startDate.from'
      }), " ").concat(formattedStartDateFrom)
    }],
    onSelect: function onSelect() {
      return startDateFilter.onInputChange(_objectSpread(_objectSpread({}, startDateFilter.inputValue), {}, {
        from: null
      }));
    }
  }), (formattedStartDateUntil === null || formattedStartDateUntil === void 0 ? void 0 : formattedStartDateUntil.length) > 0 && /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChips, {
    data: [{
      value: null,
      label: "".concat(intl.formatMessage({
        id: 'tourBoard.filter.startDate'
      }), " ").concat(intl.formatMessage({
        id: 'tourBoard.filter.startDate.until'
      }), " ").concat(formattedStartDateUntil)
    }],
    onSelect: function onSelect() {
      return startDateFilter.onInputChange(_objectSpread(_objectSpread({}, startDateFilter.inputValue), {}, {
        until: null
      }));
    }
  }), (formattedEndDateFrom === null || formattedEndDateFrom === void 0 ? void 0 : formattedEndDateFrom.length) > 0 && /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChips, {
    data: [{
      value: null,
      label: "".concat(intl.formatMessage({
        id: 'tourBoard.filter.endDate'
      }), " ").concat(intl.formatMessage({
        id: 'tourBoard.filter.endDate.from'
      }), " ").concat(formattedEndDateFrom)
    }],
    onSelect: function onSelect() {
      return endDateFilter.onInputChange(_objectSpread(_objectSpread({}, endDateFilter.inputValue), {}, {
        from: null
      }));
    }
  }), (formattedEndDateUntil === null || formattedEndDateUntil === void 0 ? void 0 : formattedEndDateUntil.length) > 0 && /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChips, {
    data: [{
      value: null,
      label: "".concat(intl.formatMessage({
        id: 'tourBoard.filter.endDate'
      }), " ").concat(intl.formatMessage({
        id: 'tourBoard.filter.endDate.until'
      }), " ").concat(formattedEndDateUntil)
    }],
    onSelect: function onSelect() {
      return endDateFilter.onInputChange(_objectSpread(_objectSpread({}, endDateFilter.inputValue), {}, {
        until: null
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChips, {
    onSelect: projectsFilter.onSelect,
    data: projectsFilter.selectedRows.map(function (value) {
      return systemExchangeProjects === null || systemExchangeProjects === void 0 ? void 0 : systemExchangeProjects.find(function (loadedType) {
        return loadedType.value === value;
      });
    }).filter(function (project) {
      return project;
    })
  }), ((_filters$values$exter2 = filters.values.externalProjectReference) === null || _filters$values$exter2 === void 0 ? void 0 : _filters$values$exter2.length) > 0 && /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.FilterChips, {
    data: [{
      value: '',
      label: filters.values.externalProjectReference
    }],
    onSelect: function onSelect(externalProjectReference) {
      return filters.update({
        externalProjectReference: externalProjectReference
      });
    }
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex flex-1 justify-end"
  }, hasPermissions(['module.tour.excelImport.download']) && /*#__PURE__*/_react["default"].createElement(_nicbaseExportButton["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.XlsToTour, null),
    className: "mr-5 self-center",
    title: intl.formatMessage({
      id: 'tourBoard.excelImport.template.download'
    }),
    onClick: function onClick() {
      return downloadTourImportTemplate(portalId);
    }
  }), hasPermissions(['module.tour.extended']) && /*#__PURE__*/_react["default"].createElement(_nicbaseExportButton["default"], {
    type: "xls",
    className: "mr-5 self-center",
    onClick: function onClick() {
      return onCreateExport(visibleColumns);
    }
  }), hasPermissions(['module.tour.extended', 'module.tour.rail']) && !hasPermissions(['module.tour.road']) ? /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
    onClick: onNewRailTour,
    raised: true,
    primary: true,
    className: "new-tour-button mr-2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "tourBoard.newTour",
    tagName: "span"
  })) : null, hasPermissions(['module.tour.extended', 'module.tour.road']) && !hasPermissions(['module.tour.rail']) ? /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
    onClick: onNewTourButtonClicked,
    raised: true,
    primary: true,
    className: "new-tour-button mr-2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "tourBoard.newTour",
    tagName: "span"
  })) : null, hasPermissions(['module.tour.extended', 'module.tour.road', 'module.tour.rail']) ? /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOut, {
    hideOnItemClick: true,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
      raised: true,
      primary: true,
      className: "new-tour-button mr-2"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "tourBoard.newTour"
    }))
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: function onClick() {
      return onNewRailTour();
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "tourBoard.rail.newTour"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: onNewTourButtonClicked
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "tourBoard.road.newTour"
  }))) : null)), isLoadingTours || isLoadingProjects ? /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null) : memorizedTable, renderDialogs(), hasPermissions(['module.tour.rail']) && (0, _mapping.isRailAsset)(state.tourToEdit.assetType) ? /*#__PURE__*/_react["default"].createElement(_railDetailsComponent["default"], {
    tour: state.tourToEdit,
    portalId: portalId,
    onCancel: onDetailsDialogClosed,
    isActive: state.isDetailsPopupActive
  }) : /*#__PURE__*/_react["default"].createElement(_detailsPopupComponent["default"], {
    key: "detailsPopup",
    tour: state.tourToEdit,
    onCancel: onDetailsDialogClosed,
    isActive: state.isDetailsPopupActive
  }), state.isIntelligentCopyPopupActive && /*#__PURE__*/_react["default"].createElement(_intelligentCopyComponent["default"], {
    key: "intelligentCopyPopup",
    onCancel: onIntelligentCopyDialogClosed,
    isActive: true,
    onSave: onTourCopy,
    tour: state.tourToCopy
  }), state.isReportExportPopupActive && /*#__PURE__*/_react["default"].createElement(_reportExportDialog["default"], {
    key: "reportExportPopup",
    portalId: portalId,
    onCancel: onReportExportDialogClosed,
    isActive: true,
    onSave: onReportExport,
    tour: state.tourToExport,
    user: user
  }), state.isAssetRequestPopupActive && /*#__PURE__*/_react["default"].createElement(_assetRequestDialog["default"], {
    key: "assetRequest",
    portalId: portalId,
    onCancel: onAssetRequestClosed,
    isActive: true,
    onSave: onAssetRequestHandler,
    tour: state.tourToAssetRequest
  })));
};

exports.TourBoardPresentation = TourBoardPresentation;

var noop = function noop() {};

TourBoardPresentation.propTypes = {
  intl: _nicbaseTranslation.intlShape.isRequired,
  filters: _nicbaseFilters.filtersShape.isRequired,
  portalId: _propTypes["default"].number.isRequired,
  id: _propTypes["default"].number.isRequired,
  isEditActive: _propTypes["default"].bool.isRequired,
  responsiveMode: _propTypes["default"].shape({
    mode: _propTypes["default"].string
  }),
  visibleColumns: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  updateSettings: _propTypes["default"].func,
  emitConnectEvent: _propTypes["default"].func,
  getAlarmInformationListFromBackend: _propTypes["default"].func.isRequired,
  getPoisFromBackend: _propTypes["default"].func.isRequired,
  getLinkedPortalsInformationListFromBackend: _propTypes["default"].func.isRequired,
  getTourAlarms: _propTypes["default"].func,
  exportTourReport: _propTypes["default"].func,
  hasPermissions: _propTypes["default"].func.isRequired,
  settings: _propTypes["default"].instanceOf(Object).isRequired,
  user: _propTypes["default"].instanceOf(Object).isRequired,
  assets: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  tourAlarms: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  linkedPortals: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  onExportDispatch: _propTypes["default"].func,
  downloadTourImportTemplate: _propTypes["default"].func
};
TourBoardPresentation.defaultProps = {
  emitConnectEvent: noop,
  getTourAlarms: noop,
  tourAlarms: [],
  visibleColumns: [],
  updateSettings: noop,
  exportTourReport: noop,
  responsiveMode: {
    mode: 'desktop'
  },
  onExportDispatch: noop,
  downloadTourImportTemplate: noop
};

var _default = (0, _nicbaseTranslation.injectIntl)((0, _nicbaseSecurity.authorize)('PORTAL')(['widget.type.26'])((0, _nicbaseFilters.withFilters)(function (_, ownProps) {
  var _ownProps$settings = ownProps.settings,
      settings = _ownProps$settings === void 0 ? {} : _ownProps$settings;
  var _settings$tourStatus = settings.tourStatus,
      tourStatus = _settings$tourStatus === void 0 ? {
    waiting: true,
    running: false,
    finished: false,
    received: false,
    requested: false
  } : _settings$tourStatus;
  return {
    tourStatus: tourStatus
  };
})(TourBoardPresentation)));

exports["default"] = _default;